import apiClient from './client'

export const progressApi = {
  // Summary, courses and exam history in one call — the server answers for
  // the authenticated student, so there is no id to pass.
  getMyProgress: async () => {
    const response = await apiClient.get('/me/progress')
    return response.data
  },
}
